import React from 'react';
import { Share2, Download, Layout, Pin } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
// import { useAuth } from "../../hooks/chat/useAuth";
import { useConversationExport } from '../../hooks/useConversationExport';
import { notify } from '../../utils/toast';

interface HeaderActionsProps {
  currentConversation: {
    id: string;
    title: string;
    created_at: string;
    updated_at: string;
    isPinned?: boolean;
    isSharedBy?: boolean;
  } | null;
  messages: any[];
  isSharedConversation?: string;
  onShare: () => void;
  onUnShare: () => void;
  onTogglePin?: () => void;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({
  currentConversation,
  messages,
  isSharedConversation,
  onShare,
  onUnShare,
  onTogglePin
}) => {
  const { state: { user } } = useAuth();
  const { downloadConversation } = useConversationExport();

  const handleDownload = async () => {
    if (!currentConversation || !user?.address) return;
    await downloadConversation(user.address, currentConversation, messages);
  };

  return (
    <div className="flex items-center space-x-1 md:space-x-2">
      {currentConversation && isSharedConversation !== 'shared' && (
        <div className="group relative">
          <button 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onTogglePin) onTogglePin();
            }}
            className={`p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors ${
              currentConversation.isPinned ? 'text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'
            }`}
          >
            <Pin size={20} className={currentConversation.isPinned ? 'rotate-45' : ''} />
          </button>
          <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
            {currentConversation.isPinned ? 'Unpin conversation' : 'Pin conversation'}
          </div>
        </div>
      )}
      {isSharedConversation !== 'shared' &&(<div className="group relative">
        <button 
          onClick={currentConversation?.isSharedBy ? onUnShare: onShare}
          className={`p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors ${
            currentConversation?.isSharedBy ? 'text-blue-600 dark:text-blue-400 transform rotate-90' : 'text-gray-700 dark:text-gray-300'
          }`}
        >
          <Share2 size={20} />
        </button>
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          {currentConversation?.isSharedBy ? 'Conversation shared' : 'Share conversation'}
        </div>
      </div>)}
      {currentConversation && (<div className="group relative">
        <button 
          onClick={handleDownload}
          disabled={!currentConversation}
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Download size={20} className="text-gray-700 dark:text-gray-300" />
        </button>
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          {currentConversation ? 'Download conversation' : 'No conversation to download'}
        </div>
      </div>)}
      {/* <div className="group relative">
        <button 
          onClick={onShare}
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
        >
          <Layout size={20} className="text-gray-700 dark:text-gray-300" />
        </button>
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Canvas view
        </div>
      </div> */}
    </div>
  );
};
